import { useEffect } from 'react'
import { I18nextProvider } from 'react-i18next'
import i18n, { countryToLocale } from './index'
import { getCookie } from '../utils/cookieUtils'
import { VALID_COUNTRIES } from '../context/CountryContext'

function resolveLocaleFromPath() {
  const match = window.location.pathname.match(/^\/(ba|rs)(\/|$)/)
  if (match) return countryToLocale(match[1])
  return null
}

function resolveLocaleFromCookie() {
  const saved = getCookie('selectedCountry')
  if (saved && VALID_COUNTRIES.includes(saved)) {
    return countryToLocale(saved)
  }
  return null
}

export function syncLocaleWithCountry(countryCode) {
  const locale = countryToLocale(countryCode)
  if (i18n.language !== locale) {
    i18n.changeLanguage(locale)
  }
}

export function I18nProvider({ children, countryCode }) {
  useEffect(() => {
    const locale =
      (countryCode && countryToLocale(countryCode)) ||
      resolveLocaleFromPath() ||
      resolveLocaleFromCookie() ||
      'ba'

    if (i18n.language !== locale) {
      i18n.changeLanguage(locale)
    }
  }, [countryCode])

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}

export default I18nProvider
